import { render, staticRenderFns } from "./TableRowHaOpportunitiesByAudiologist.vue?vue&type=template&id=640e55e2&lang=pug&"
import script from "./TableRowHaOpportunitiesByAudiologist.vue?vue&type=script&lang=js&"
export * from "./TableRowHaOpportunitiesByAudiologist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640e55e2')) {
      api.createRecord('640e55e2', component.options)
    } else {
      api.reload('640e55e2', component.options)
    }
    module.hot.accept("./TableRowHaOpportunitiesByAudiologist.vue?vue&type=template&id=640e55e2&lang=pug&", function () {
      api.rerender('640e55e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/annually/TableRowHaOpportunitiesByAudiologist.vue"
export default component.exports